import { Brain, Building2, CalendarDays, Newspaper } from "lucide-react";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { cn } from "@/lib/utils";
import type { ViewId } from "@/components/layout/AppShell";

const TABS: { id: ViewId; label: string; Icon: typeof Building2 }[] = [
  { id: "companies", label: "Companies", Icon: Building2 },
  { id: "predictions", label: "Models", Icon: Brain },
  { id: "news", label: "News", Icon: Newspaper },
  { id: "calendar", label: "Calendar", Icon: CalendarDays },
];

export function BottomTabBar({
  view,
  setView,
  className,
}: {
  view: ViewId;
  setView: (v: ViewId) => void;
  className?: string;
}) {
  return (
    <nav
      className={cn(
        "h-12 border-t border-border bg-background shrink-0 pb-[env(safe-area-inset-bottom)]",
        className,
      )}
    >
      <ToggleGroup
        type="single"
        value={view}
        onValueChange={(v) => v && setView(v as ViewId)}
        className="h-full w-full grid grid-cols-4 gap-0 rounded-none p-0 bg-transparent"
      >
        {TABS.map(({ id, label, Icon }) => (
          <ToggleGroupItem
            key={id}
            value={id}
            aria-label={label}
            className="h-full rounded-none flex-col gap-0.5 text-[10px] font-medium data-[state=on]:bg-accent data-[state=on]:text-foreground"
          >
            <Icon className="!h-4 !w-4" />
            <span>{label}</span>
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </nav>
  );
}
